<template>
  <div class="container">
    <div class="card">
      <div class="card-header">
        <div class="card-title">
          <fai icon="user"/>&nbsp;Registrar Impulsor
        </div>
      </div>
      <div class="card-body pb-5">
        <!--begin: Details -->
          <div class="row mt-4">
            <div class="col-sm-6">
              <h4 class="font-info">Datos Generales</h4>
            </div>
          </div>
          <sys-form :inputs="promoter_details"/>
        <!--end: Details -->
        <hr class="mt-4"/>
        <!--begin: Fiscal Info -->
          <div class="row mt-4">
            <div class="col-sm col-md col-lg">
              <h4 class="m--font-info">Datos fiscales</h4>
            </div>
          </div>
          <sys-form :inputs="promoter_fiscal"/>
        <!--end: Fiscal Info -->
        <hr class="mt-4"/>
        <!--begin: Bank Data -->
          <div class="row mt-4">
            <div class="col-sm col-md col-lg">
              <h4 class="m--font-info">Datos bancarios</h4>
            </div>
          </div>
          <sys-form :inputs.sync="promoter_bank_account"/>
        <!--end: Bank Data -->
      </div>
      <div class="card-footer text-right">
        <button class="btn btn-secondary" @click="$router.push({ name: 'promoters' })">
          <fai icon="reply"/> Cancelar
        </button>
        <button class="btn btn-success" :class="{ 'disabled': form.isSaving }" @click="saveForm">
          <fai :icon="['far','edit']"/> Guardar
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import banksService from '@/services/banks'
import promotersService from '@/services/promoters'
import SysForm from '@/components/shared/Form'
import formMixin from '@/mixins/form'

export default {
  name: 'PromoterCreate',

  components: { SysForm },

  mixins: [ formMixin ],

  data () {
    return {
      promoter_details: {
        name: {
          name: 'Nombre',
          hint: 'Nombre',
          value: '',
          type: 'text',
          size: 3,
          validate: 'required'
        },
        lastname_father: {
          name: 'Apellido Paterno',
          hint: 'Apellido',
          value: '',
          type: 'text',
          size: 3,
          validate: 'required'
        },
        lastname_mother: {
          name: 'Apellido Materno',
          hint: 'Apellido',
          value: '',
          type: 'text',
          size: 3,
          validate: 'required'
        },
        type: {
          name: 'Tipo',
          value: '',
          type: 'select',
          options: [
            { value: 'Fisica', text: 'Física', selected: true },
            { value: 'Moral', text: 'Moral' }
          ],
          size: 3
        },
        email: {
          name: 'Correo',
          hint: 'Correo',
          value: '',
          type: 'email',
          size: 8
        },
        telephone: {
          name: 'Teléfono',
          hint: 'Teléfono',
          value: '',
          type: 'text'
        },
        curp: {
          name: 'CURP',
          hint: 'CURP',
          value: '',
          type: 'text',
          size: 3
        },
        nationality: {
          name: 'Nacionalidad',
          hint: 'Nacionalidad',
          value: '',
          type: 'text',
          size: 3
        },
        dob: {
          name: 'Fecha de Nacimiento',
          value: '',
          type: 'date',
          size: 3
        },
        comision: {
          name: 'Comisión',
          value: '',
          type: 'text',
          validate: 'required',
          size: 3
        },
        comision_interest: {
          name: 'Comisión de Intereses',
          hint: 'Comisión de Intereses',
          value: '',
          type: 'select',
          options: [{ value: false, text: 'No', selected: true }, { value: true, text: 'Sí' }],
          validate: 'required'
        }
      },
      promoter_fiscal: {
        rfc: {
          name: 'RFC',
          hint: 'RFC',
          value: '',
          type: 'text'
        },
        street: {
          name: 'Calle',
          hint: 'Calle',
          value: '',
          type: 'text'
        },
        number: {
          name: 'Número ext./int.',
          hint: 'Número ext./int.',
          value: '',
          type: 'number',
          min: 0,
          max: 9999
        },
        neighborhood: {
          name: 'Colonia',
          hint: 'Colonia',
          value: '',
          type: 'text'
        },
        city: {
          name: 'Municipio',
          hint: 'Municipio',
          value: '',
          type: 'text'
        },
        state: {
          name: 'Estado',
          hint: 'Estado',
          value: '',
          type: 'text'
        }
      },
      promoter_bank_account: {
        holder: {
          name: 'Cuentahabiente',
          hint: 'Cuentahabiente',
          value: '',
          type: 'text',
          size: 6
        },
        bank_id: {
          name: 'Banco',
          hint: 'Seleccione un banco',
          value: null,
          type: 'select',
          size: 6,
          options: []
        },
        account: {
          name: 'Número de cuenta',
          hint: 'Número de cuenta',
          value: '',
          type: 'number',
          size: 6,
          validate: 'isBankAccount'
        },
        clabe: {
          name: 'CLABE',
          hint: 'CLABE',
          value: '',
          type: 'number',
          size: 6,
          validate: 'isClabe'
        }
      }
    }
  },

  created: function () {
    banksService.list().then(res => {
      this.promoter_bank_account.bank_id.options = res.map(bank => {
        return {value: bank.id, text: bank.name}
      })
    })
  },

  methods: {
    saveForm: function () {
      this.$validator.validateAll().then((result) => {
        if (result) {
          let body = this.processForm(this.promoter_details)

          let bankData = this.processForm(this.promoter_bank_account)
          if (Object.keys(bankData).length) body['bank_data'] = bankData
          let fiscalData = this.processForm(this.promoter_fiscal)
          if (Object.keys(fiscalData).length) body['fiscal_address'] = fiscalData

          let service = promotersService.post(body)

          this.sendForm(service).then(res => {
            this.$router.push({ name: 'promoters' })
          }).catch(err => {
            console.log(JSON.stringify(err.statusText))
          })
        }
      })
    }
  },
  watch: {
    'promoter_details.type.value': function (type, oldType) {
      if (type.value === 'Moral') {
        this.promoter_details['corporate_name'] = {
          name: 'Nombre corporativo',
          hint: 'Nombre corporativo',
          value: '',
          type: 'text'
        }
      } else if (type.value === 'Fisica') {
        delete this.promoter_details['corporate_name']
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/promoters/PromoterCreate.vue